import React from 'react'
import styles from '../components/componentsStyles/Home.module.css';
import ContactForm from '../components/homeComponents/ContactForm';
import FirstComponent from '../components/homeComponents/FirstComponent';
import HomeSlider from '../components/homeComponents/HomeSlider';


const Home = () => {

  return (
    <div >
      <div className={styles.firstComponent}>
        <FirstComponent/>
      </div>
      
        
      <div className={styles.secondComponent2}>
        <HomeSlider/>
      </div>
      

      <div className={styles.contactForm} id ='home-contact-form'>
        <ContactForm/>
      </div>
        

    </div>
  )
}

export default Home